module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"404":"404 error","pageNotFound":"Page not found","toMainPage":"Go to the main page","companyInfo":"Company information","contactUs":"Contact us"}}')
  delete Component.options._Ctor
}
